const formatNumber = (number: number | string) =>
  Number(number)?.toLocaleString('en-US', {
    maximumFractionDigits: 0,
  });

export default formatNumber;
